import { Link } from 'react-router-dom';

export function NotFoundPage(): React.JSX.Element {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="text-4xl font-bold text-foreground">404</h1>
      <p className="mt-2 ibe-muted">Page not found</p>
      <Link to="/" className="ibe-primary-button mt-4">
        Back to home
      </Link>
    </div>
  );
}
